
















// import { Component, Mixins } from 'vue-mixin-decorator';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class FtCombobox extends Vue {
  @Prop() value!: any;
  @Prop() label!: string;
  public colors = ['green', 'purple', 'indigo', 'cyan', 'teal', 'orange'];
}
